import { render, staticRenderFns } from "./FormSignatureNew.vue?vue&type=template&id=4fe52dfe"
import script from "./FormSignatureNew.vue?vue&type=script&lang=js"
export * from "./FormSignatureNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports